import React from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {FormProvider, useForm} from "react-hook-form";
import ContactFormComponent from "./ContactFormComponent";
import Contact from "../../../Models/Contact";
import Client from "../../../Models/Client";
import {RootState} from "../../../Store/Reducers";
import {ContactsActions} from "../../../Store/Contact/Slice";
import {ModalActions} from "../../../Store/Modal/Slice";
import {CONTACT_MODAL} from "../../../Store/Modal/Types";
import {getModalTitle} from "../../../Utils/Utils";
import ModalFooterWithButtons from "../ModalFooterWithButtonsComponent";


interface IContact {
  contact_name: string;
  contact_last_name: string;
  contact_cellphone: string;
  contact_phone: string;
  contact_email: string;
  contact_costumer: string;
}

const toIContact = (contact: Contact) :IContact => {
  return {
    contact_name: contact.name,
    contact_last_name: contact.last_name,
    contact_cellphone: contact.cellphone,
    contact_phone: contact.phone,
    contact_email: contact.email,
    contact_costumer: (contact.customer as Client)?._KEY || contact.customer as string,
  }
}

const ContactModalComponent = () => {

  const { contactModal } = useSelector((state: RootState) => state.ModalReducer);
  const { formType, model, refreshContacts } = contactModal.data;

  const { loadingSaveContact } = useSelector((state: RootState) => state.LoadingReducer);

  const clientId = model?.customer || model;
  const contact = (typeof model === "string" ? {}: model) as Contact;

  const form = useForm<IContact>({ defaultValues: toIContact(contact) });

  const { handleSubmit } = form;

  const dispatch = useDispatch();

  const onSubmit = (data: IContact) => {
    const params: Contact = {
      _KEY: contact._KEY,
      name: data.contact_name,
      last_name: data.contact_last_name,
      cellphone: data.contact_cellphone,
      phone: data.contact_phone,
      email: data.contact_email,
      customer: clientId
    }
    dispatch(ContactsActions.saveContact({
      contact: params,
      refreshContacts
    }));
  }

  const onClose = () => {
    dispatch(ModalActions.closeModal({
      modal: CONTACT_MODAL
    }))
  }

  return (
    <Modal
      isOpen={contactModal.open}
      size="lg"
    >
      <ModalHeader>{ getModalTitle(formType, "Contacto") }</ModalHeader>
      <ModalBody>
        <FormProvider {...form}>
          <ContactFormComponent contact={contact}/>
        </FormProvider>
      </ModalBody>
      <ModalFooterWithButtons
        onSave={handleSubmit(onSubmit)}
        onClose={onClose}
        isLoading={loadingSaveContact.status.isLoading()}
      />
    </Modal>
  );
};
export default ContactModalComponent;
